import React, { useState, useCallback } from 'react';
import { Autocomplete, TextField, Typography, Box } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import { http } from '../../../api/http';

interface PersonaOption {
  id: number;
  identificacion: string;
  personaContacto: string;
}

export const CustomerSearch: React.FC = () => {
  const [options, setOptions] = useState<PersonaOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<PersonaOption | null>(null);

  const searchCustomers = useCallback(async (query: string) => {
    if (!query || query.length < 2) {
      setOptions([]);
      return;
    }
    setLoading(true);
    try {
      const response = await http.get('/catalog/personas');
      const personas: PersonaOption[] = response.data;
      const filtered = personas.filter(
        (p) =>
          p.personaContacto?.toLowerCase().includes(query.toLowerCase()) ||
          p.identificacion?.includes(query)
      );
      setOptions(filtered.slice(0, 20));
    } catch {
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <Autocomplete
      size="small"
      options={options}
      loading={loading}
      value={selectedCustomer}
      onChange={(_e, value) => setSelectedCustomer(value)}
      onInputChange={(_e, value) => searchCustomers(value)}
      getOptionLabel={(option) => `${option.identificacion} - ${option.personaContacto}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      noOptionsText="Busque por nombre o documento"
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option.id}>
          <PersonIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} />
          <Box>
            <Typography variant="body2">{option.personaContacto}</Typography>
            <Typography variant="caption" color="text.secondary">{option.identificacion}</Typography>
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Cliente (opcional)"
          variant="outlined"
          sx={{ mt: 0.5 }}
        />
      )}
    />
  );
};

export default CustomerSearch;
